import Vue from 'vue'
import scenarioActionTypes from './modules/scenario/scenario.type'
import userActionTypes from './modules/user/user.type'
import campaignActionTypes from "@/store/modules/campaign/campaign.type";
import QCCampaignActionTypes from "@/store/modules/qccampaign/qccampaign.type";
import debugActionTypes from "@/store/modules/debug/debug.type";
import AgentActionTypes from "@/store/modules/agent/agent.type";
// naming convention
// raw name mean set, LOADING => mean set LOADING

// user store
let userActionTypesShortcut = {...userActionTypes}

Object.keys(userActionTypes).forEach(item => {
    userActionTypesShortcut[item] = 'user/' + userActionTypes[item]
})

// campaign store
let campaignActionTypesShortcut = {...campaignActionTypes}

Object.keys(campaignActionTypes).forEach(item => {
    campaignActionTypesShortcut[item] = 'campaign/' + campaignActionTypes[item]
})

// scenario store
let scenarioActionTypesShortcut = {...scenarioActionTypes}

Object.keys(scenarioActionTypes).forEach(item => {
    scenarioActionTypesShortcut[item] = 'scenario/' + scenarioActionTypes[item]
})

// qc campaign store
let qcCampaignActionTypesShortcut = {...QCCampaignActionTypes}

Object.keys(QCCampaignActionTypes).forEach(item => {
    qcCampaignActionTypesShortcut[item] = 'qccampaign/' + QCCampaignActionTypes[item]
})

// debug store
let debugActionTypesShortcut = {...debugActionTypes}

Object.keys(debugActionTypes).forEach(item => {
    debugActionTypesShortcut[item] = 'debug/' + debugActionTypes[item]
})

// agent store
let agentActionTypesShortcut = {...AgentActionTypes}
Object.keys(AgentActionTypes).forEach(item => {
    agentActionTypesShortcut[item] = 'agent/' + AgentActionTypes[item]
})

// main store
const actionTypes = {
    // common for both action and mutation in main store
    LOADING: 'LOADING',
    DATA_LOADING: 'DATA_LOADING',
    TOGGLE_NAVIGATION: 'TOGGLE_NAVIGATION',
    NAVIGATION: 'NAVIGATION',
    VERSION: 'VERSION',
    TOUR_CONSOLE: 'TOUR_CONSOLE',
    TOKEN: 'TOKEN',
    user: userActionTypesShortcut,
    campaign: campaignActionTypesShortcut,
    scenario: scenarioActionTypesShortcut,
    qccampaign: qcCampaignActionTypesShortcut,
    debug: debugActionTypesShortcut,
    agent: agentActionTypesShortcut,
}

Vue.prototype.$actionTypes = actionTypes

export {
    userActionTypes, campaignActionTypes, scenarioActionTypes, actionTypes, QCCampaignActionTypes, debugActionTypes
}
